import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { IonContent, NavParams, Platform } from '@ionic/angular';
import { AuthenticationService } from 'src/app/services/authentication/authentication.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { SuccessMessageService } from 'src/app/services/message-provider/success-message.service';
import { UploadDocumentService } from 'src/app/services/upload-document/upload-document.service';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { EventsService } from 'src/app/services/event/event.service';
import { Navigator } from 'src/app/services/routing/navigator';
import { RoutingService } from 'src/app/services/routing/routing.service';

@Component({
  selector: 'app-secure-uplod-document',
  templateUrl: './secure-uplod-document.component.html',
  styleUrls: ['./secure-uplod-document.component.scss'],
})
export class SecureUplodDocumentComponent implements OnInit {

  @ViewChild(IonContent, { static: false }) content: IonContent;
  @ViewChild("fileInput")  fileInput: ElementRef;
  @ViewChild("fileInputAddress")  fileInputAddress: ElementRef;
  @ViewChild("fileInputFinancials") fileInputFinancials: ElementRef;
  @ViewChild("fileInputOther") fileInputOther: ElementRef;
  
  public tokenURL: string;
  public tokenInfo: string;
  private customerID;
  public error: any = null;
  public showUI: boolean = false;
  public fb: FormGroup;
  protected formData: FormData;

  fileObject = {};
  filteredObject = [];
  displayNamePhotoID:string = '';
  displayNameAddress:string = '';
  displayNameFinancials:string = '';
  displayNameOther:string = '';
  displayName:string = '';
  itemSelected:boolean = false;
  clearButtonEnabled:boolean = false;
  validDocumentList = [];

  constructor(
     public navParams: NavParams,
     public utils: UtilsService,
     public successMessageService: SuccessMessageService,
     private uploadDocumentProvider:UploadDocumentService,
     private events: EventsService,
     private navigator: Navigator,
     private config: ConfigService,
     private platform: Platform,
     public authenticationService: AuthenticationService,
     private routing:RoutingService
  ) {
    let holdURL = this.navParams.get('tokenURL');
    console.log(holdURL)
    let getQueryString = holdURL.split("?")[1]
    let token = getQueryString.split('=')[1];
    this.tokenURL = token.split('#')[0];
    this.getToken(this.tokenURL);
  }

  ngOnInit() {
    this.itemSelected = false;
    this.clearButtonEnabled = false;
    this.fb = new FormGroup({});
    this.formData = new FormData();
    const tempDocList = this.config.getConfig().FEATURE_UPLOAD_DOCUMENT_LIST ? this.config.getConfig().FEATURE_UPLOAD_DOCUMENT_LIST : "Passport:State issued ID:Copy of Patron's Security Card:Proof of residence in the form of a bill addressed to the patron at their provided address";

    this.validDocumentList = tempDocList?.split(":");
    if(this.platform.is("ios") && this.platform.is("capacitor")){
      this.clearInputsNamesMessages();
    }
  }

  getToken(data) {
    if (data) {
        this.utils.removeUrlParams();
        this.onValidateToken(data);
    } else {
        console.log('token not received');
    } 
  }

  onValidateToken(token) {
    this.tokenInfo = token;
    this.authenticationService.callValidateSecureUploadDocumentToken(token).subscribe(
        (response: any) => {
            if (response && !!response.result) {
                this.showUI = true;
                this.customerID = response.payload
            }
        },
        (error) => {
            switch (error.getErrorCode().toUpperCase()) {
                case 'INVALID_TOKEN':
                    error.setErrorMessage('The token provided is invalid');
                    break;
                case "TOKEN_EXPIRED":
                    error.setErrorMessage('The token provided is expired');
                    break;
                default:
                    error.setErrorMessage('The token provided is expired');
                    break;
            }

            this.error = error;
            this.content.scrollToTop(10);
        }
    );
  }

  onFileChange(event, documenttype) {
    this.fileObject = {};
    this.itemSelected = true;
    this.clearButtonEnabled = true;
    this.successMessageService.clearMessage();
    if(event.target.files && event.target.files.length > 0) {    
      
      // Clearing the old file after changing the new file upload
      if (this.formData.has(documenttype)) {
        this.formData.delete(documenttype);
      }

      this.formData.append(documenttype,event.target.files[0], event.target.files[0].name);
      this.formData.append('document_type',documenttype);
     
      if(documenttype == 'photo_id'){
        this.displayNamePhotoID =  event.target.files[0].name;
      }
      if(documenttype == 'address'){
        this.displayNameAddress =  event.target.files[0].name;
      }
      if(documenttype == 'financials'){
        this.displayNameFinancials =  event.target.files[0].name;
      }
      if(documenttype == 'other'){
        this.displayNameOther =  event.target.files[0].name;
      }
    }
  }

  onSubmit() {
    this.formData.append('customer_id',this.customerID);
    this.formData.append('encrypted_customer_info_token',this.tokenInfo);
    this.postData(this.formData);
  }

  postData(formData: FormData){
    this.uploadDocumentProvider.callSecureUploadDocumentFile(formData)
      .subscribe(
        (response: any) => {
          if(response.result){
            this.error = null;
            this.successMessageService.setMessage("Your documents have been uploaded.");
            this.content.scrollToTop(10);
            this.showUI = false;
            /*this.formData = new FormData(); //reset formData
            this.clearButtonEnabled = true;
            this.itemSelected = false;
            setTimeout(() => {
              this.clearFileInputsNames();
            }, 3000);*/

          }
        },
        (error) => {
          console.error("Upload Documents", error);
          this.error = error;
          switch (error.getErrorCode().toUpperCase()) {
            case 'FILES_REJECTED':
                error.setErrorMessage(error.error_payload.errors[0]);
                break;
            default:
                error.setErrorMessage('An error has occured. Please try again.');
                break;
          }
          this.formData = new FormData();
          this.content.scrollToTop(10);
          this.clearButtonEnabled = true;
          this.itemSelected = false;
          setTimeout(() => {
            this.clearFileInputsNames();
          }, 3000);
        }
      )
  }

  //clear page
  clearFileInputsNames() {
    this.fileInput.nativeElement.value = '';
    this.fileInputAddress.nativeElement.value = '';
    this.fileInputFinancials.nativeElement.value = '';
    this.fileInputOther.nativeElement.value = '';
    this.clearFileNames();
  }
  //clear Inputs, Display Names and Success/Error messages
  clearInputsNamesMessages() {
    this.formData = new FormData();
    this.itemSelected = false;
    this.clearButtonEnabled = false;
    this.error = null;
    this.successMessageService.clearMessage();
    this.clearFileInputsNames();
  }
  //clear file names
  clearFileNames(){
    this.displayNamePhotoID = '';
    this.displayNameAddress = '';
    this.displayNameFinancials = '';
    this.displayNameOther = '';
  }

  closeModal = () => {
    this.events.publish("event:lobby:show");
    this.navigator.dismissAll();
    this.routing.defaultRoute(true);
  }

}
